import { defineNuxtPlugin } from "#app";
import { useDirectApp } from "./composable";

export default defineNuxtPlugin(() => {
  const { setupMessageListener } = useDirectApp();

  setupMessageListener();
});
